import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-new-contact-us-details',
  templateUrl: './new-contact-us-details.component.html',
  styleUrls: ['./new-contact-us-details.component.scss']
})
export class NewContactUsDetailsComponent implements OnInit {

    productId: string | null = null;

employee: any = {
  status: '',

};

  showStatusModal = false;
  selectedStatus = '';
statusText: string = ''; 

  product: any = {
    status: '',
    email: '',

  };

 
   employeeId: string | null = null;

constructor(
    private route: ActivatedRoute,
    private router: Router,
    private apiService: ApisService,
    private toastr: ToastrService,
    private translate: TranslateService
  ) {}
    ngOnInit(): void {
    // get product id from route
   this.employeeId = this.route.snapshot.paramMap.get('id');
    if (this.employeeId) {
      this.loadEmployee(this.employeeId);
    }


        
  }


loadEmployee(id: string): void {
  this.apiService.getContactUsById(id).subscribe({
    next: (res: any) => {
      if (res?.data) {
        this.employee = res.data;
        console.log('Contact details:', this.employee);
      }
    },
    error: (err) => {
      console.error('Failed to load employee:', err);
      this.toastr.error('Failed to load employee details');
    }
  });
}



openStatusModal(): void {
  this.selectedStatus = this.employee.status || ''; // 👈 prefill with existing status
  this.showStatusModal = true;
}


  closeStatusModal(): void {
    this.showStatusModal = false;
  }

  updateStatus(): void {
    if (!this.employeeId) return;
    const formData = new FormData();
    formData.append('status', this.selectedStatus);

    this.apiService.editContactUs(this.employeeId, formData).subscribe({
      next: () => {
        this.toastr.success(this.translate.instant('MENU.DASHBOARD.status_updated_successfully'));
        this.employee.status = this.selectedStatus;
        this.closeStatusModal();
      },
      error: (err) => {
        console.error('Status update failed:', err);
        this.toastr.error(this.translate.instant('MENU.DASHBOARD.failed_to_update_status'));
      }
    });
  }



}
